import { TableCell, TableRow } from "@mui/material";

export const TableHeaderRow = () => {
  return (
    <TableRow>
      <TableCell sx={{ px: 3, py: 1.25 }}>Name</TableCell>
      <TableCell sx={{ px: 3, py: 1.25, width: 200 }}>Assigned By</TableCell>
      <TableCell sx={{ px: 3, py: 1.25, width: 160 }}>Date Assigned</TableCell>
      <TableCell sx={{ px: 3, py: 1.25, width: 160 }}>Assignment</TableCell>
      <TableCell sx={{ px: 3, py: 1.25 }}>Status</TableCell>
    </TableRow>
  );
};
